module.exports = __webpack_public_path__ + "img/homeBanner.6004a66b.png";